<app-page [pageTitleWithoutTranslate]="(name$ | async) || ('reports.new_report' | translate)"
          [contentFullHeight]="true"
          [iframe]="iframe"
          [loader]="loading$ | async"
          *ngIf="authorize$ | async; else unauthorize">
  <div pageInfo *ngIf="!iframe" class="overflow-hidden display-flex flex-align-center subtitle gap-1-rem">
    <h3 class="subtitle text-ellipsis">{{'reports.' + (reportType$ | async) | translate}}</h3>
    <app-report-beta-badge *ngIf="beta"></app-report-beta-badge>
    <app-report-wallgarden-badge *ngIf="['transaction-id','path-explorer','affinity'].includes(reportType$ | async) && false"></app-report-wallgarden-badge>
    <app-report-public-badge *ngIf="!(publicMode$ | async) && (isPublic$ | async)"
                             [link]="publicLink$ | async"
                             (click)="onOpenPublicSharingDialog()"></app-report-public-badge>
  </div>
  <div actions *ngIf="!iframe" class="display-flex flex-align-center gap-2em">
    <ng-container *ngIf="!(publicMode$ | async); else publicActions">
      <div id="params-options" class="display-flex flex-align-center gap-2em" *ngIf="!['transaction-id','path-explorer','affinity'].includes(reportType$ | async)">
        <app-real-conversions-button *ngIf="!['transaction-id','path-explorer','affinity'].includes(reportType$ | async)"></app-real-conversions-button>
        <app-autocorrect-consent-button></app-autocorrect-consent-button>
      </div>
      <div class="display-flex flex-align-center gap-1-rem">
        <app-help-button [template]="helpTemplate$ | async"
                         [withText]="false"
                         *ngIf="helpTemplate$ | async"></app-help-button>
        <ng-content select="[actions]"></ng-content>
        <app-fullscreen-button [withText]="false"></app-fullscreen-button>
        <app-report-save-button [reportType]="reportType$ | async"
                                [report]="report$ | async"
                                [disabled]="!(submitted$ | async)"></app-report-save-button>
        <app-report-download-button [disabled]="!(submitted$ | async)"
                                    [reportData]="route.data | async"
                                    *ngIf="!disableDownloads"></app-report-download-button>
        <app-report-share-button [disabled]="!(submitted$ | async)"
                                 [report]="report$ | async"
                                 [disableExports]="disableExports"
                                 [disablePublic]="disablePublic"></app-report-share-button>
      </div>
    </ng-container>
    <ng-template #publicActions>
      <div class="display-flex flex-align-center gap-1-rem">
        <app-report-period-setting-button [disableComparison]="disableComparison"></app-report-period-setting-button>
        <app-report-info-button></app-report-info-button>
        <app-fullscreen-button [withText]="false"></app-fullscreen-button>
      </div>
    </ng-template>
  </div>
  <div parameters *ngIf="!iframe && !(publicMode$ | async)">
    <app-jumbotron>
      <app-report-params class="display-block"
                         [actionsConfigs]="actionsConfigs$ | async"
                         [paramsConfigs]="paramsConfigs$ | async"
                         [paramsDropdownConfigs]="paramsDropdownConfigs$ | async"
                         (onReady)="onReady.emit()"></app-report-params>
    </app-jumbotron>
  </div>
  <app-jumbotron class="full-height" content>
    <ng-content></ng-content>
  </app-jumbotron>
</app-page>
<ng-template #unauthorize>
  <app-page [loader]="false">
    <div content class="display-flex justify-content full-height flex-align-center">
      <app-message-box [dropdown]="false">
        <div class="pt-1em pb-1em">
          <div>{{ 'reports.trying_to_open_private_report' | translate }}</div>
          <div>{{ 'reports.contact_owner' | translate: {
            owner: owner$ | async,
            report: name$ | async
          } }}</div>
        </div>
      </app-message-box>
    </div>
  </app-page>
</ng-template>
